<template>
  <main class="container py-4" role="main">
    <h4>{{ $t("createNewCustomer") }}</h4>

    <b-form class="form-container" @submit.prevent="submitForm">
      <template>
        <b-form-row>
          <b-form-group class="col-lg-6">
            <template v-slot:label>{{ $t("fullName") }} <span class="text-danger">*</span></template>
            <b-form-input
              type="text"
              v-model="name"
              autocomplete="name"
              required
              minlength="2"
              maxlength="100"
              :pattern=fullNamePattern
              @invalid="$event.target.setCustomValidity($t('FormatInvalidName'))"
              @input.native="$event.target.setCustomValidity('')"
            />
          </b-form-group>
          <b-form-group class="col-lg-6">
            <template v-slot:label>{{ $t("phoneNumber") }} <span class="text-danger">*</span></template>
            <b-form-input type="tel" v-model.trim="phoneNumber" required :pattern="phonePattern" minlength="2" maxlength="50"
              @invalid="$event.target.setCustomValidity($t('invalidPhoneFormat'))"
              @input.native="$event.target.setCustomValidity('')" />
          </b-form-group>
        </b-form-row>
        <b-form-row>
          <b-form-group class="col-lg-6" :description="$t('usernameDescription')">
            <template v-slot:label>Tên đăng nhập <span class="text-danger">*</span></template>
            <b-form-input type="text" v-model.trim="username" required minlength="2"
              maxlength="32" />
          </b-form-group>
          <b-form-group class="col-lg-6">
            <template v-slot:label>Email <span class="text-danger">*</span></template>
            <b-form-input v-model.trim="email" type="email" required maxlength="100" autocomplete="email" />
          </b-form-group>

        </b-form-row>
        <b-form-row>
          <b-form-group class="col-lg-6 mb-1">
            <b-input-group >
              <b-form-input v-model.trim="password" required type="text" class="text-monospace custom-validity-fix" autocomplete="off"
                :minlength="passwordPolicy.minPasswordLength" :maxlength="passwordPolicy.maxPasswordLength"
                :pattern="passwordPolicy.passwordPattern" @invalid="handleInvalid"
                @input.native="handleInput"></b-form-input>
              <b-input-group-append>
                <b-button class="btn-form" variant="outline-secondary" v-b-tooltip :title="$t('createRandomAccessCode')"
                  @click="setRandomPassWord">
                  <b-icon-arrow-repeat />
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <template v-slot:label>{{ $t("password") }} <span class="text-danger">*</span></template>
          </b-form-group>
          <b-form-group class="col-lg-6 mb-1">
            <template v-slot:label>{{ $t("confirmPassword") }} <span class="text-danger">*</span></template>
            <b-form-input type="text" class="masked-password" autocomplete="off" v-model="confirmPassword" required />
          </b-form-group>
        </b-form-row>
        <small class="form-text text-muted mb-3">{{ passwordPolicy.passwordDescription }}</small>
        <b-form-group v-if="isUserAdmin() || isUserSuperAdmin()">
          <template v-slot:label>{{ $t("saleArea2") }} <span class="text-danger">*</span></template>
          <b-form class="d-flex align-items-center" required>
            <b-form-select :options="areaFilterOptions" v-model="areaFilterSelectedOption" />
          </b-form>
        </b-form-group>

        <b-form-group>
          <template v-slot:label>{{ $t("address") }} <span class="text-danger">*</span></template>
          <b-form-textarea v-model="address" required maxlength="200" />
        </b-form-group>

        <div v-if="formErrorMsg" class="text-danger" v-html="formErrorMsg"></div>

        <div class="text-center">
          <b-button type="submit" variant="primary" :disabled="isSubmitting" class="mt-4">{{ $t("createCustomer")
            }}</b-button>
        </div>
      </template>
    </b-form>
  </main>
</template>

<style lang="scss" scoped>
.form-container {
  max-width: 700px;
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import _ from "lodash";
import BaseComponent from "@/components/BaseComponent";
import * as areaService from "@/service/areaService";
import * as customerService from "@/service/customerService";
import * as userService from "@/service/userService";
import * as validationUtils from "@/service/validationUtils";
import * as passwordPolicyService from "@/service/passwordPolicyService";

import provinces from "@/provinces.json";
import * as util from "@/service/util";
@Component
export default class CreateNewCustomer extends BaseComponent {

  datePickerFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
  code = "1234";
  isLoading = true;
  passwordPolicy = {
    minPasswordLength: 8,
    maxPasswordLength: 16,
    passwordPattern: ".*",
    passwordValidationFailedMessage: "Mật khẩu không hợp lệ",
    passwordDescription: "Mật khẩu phải có ít nhất 8 ký tự bao gồm chữ số, chữ in hoa và ký tự đặc biệt.",
  };
  areaFilterSelectedOption: number = null;
  areaFilterOptions = [];
  password = "";
  confirmPassword = "";
  username = "";
  name = "";
  email = "";
  phoneNumber = "";
  address = "";
  taxCode = "";
  documentTypeId: number = null;
  // documentTypeOptions = [];
  documentIssuePlace = "";
  documentIssueDate = null;
  documentExpiryDate = null;
  idCard = "";
  description = "";
  recordingStorage = 1000;
  formErrorMsg = "";
  isSubmitting = false;
  corporationTypeOptions = [
    { value: "invnpt", text: this.$t("invnpt").toString() },
    { value: "outside", text: this.$t("outside").toString() },
  ];
  corporationType = "invnpt";
  provinceOptions = provinces;
  province = "";
  corporation = "";
  corporationOptionsIn = [
    { value: "vinaphone", text: this.$t("vinaphone").toString() },
    { value: "media", text: this.$t("media").toString() },
    { value: "net", text: this.$t("net").toString() },
    { value: "vt_ttp", text: this.$t("vt_ttp").toString() },
    { value: "tdagency", text: this.$t("tdagency").toString() },
    { value: "it", text: this.$t("it").toString() },
    { value: "other", text: this.$t("other").toString() },
  ];
  corporationOptionsOut = [
    { value: "personal", text: this.$t("personal").toString() },
    { value: "business", text: this.$t("business").toString() },
    { value: "organ", text: this.$t("organ").toString() },
    { value: "other", text: this.$t("other").toString() },
  ];
  mounted() {
    this.fetchPasswordPolicy();
    // this.fetchDocumentTypes();
    this.fetchAreas();
  }

  // async fetchDocumentTypes() {
  //   try {
  //     const docTypes = await customerService.getDocumentTypes();
  //     this.documentTypeOptions = docTypes.map(it => ({ value: it.id, text: it.title }));

  //   } catch (e) {
  //     this.toastError(e);
  //   }
  // }

  ///
  async fetchAreas() {
    try {
      const areas = await areaService.getAll();
      this.areaFilterOptions = areas.map(it => ({ value: it.id, text: it.name }));
      // this.areaFilterOptions.unshift({ value: null, text: this.$t("all").toString() });

    } catch (e) {
      this.toastError(e);
    }
  }

  ///
  handleInvalid(event) {
    event.target.setCustomValidity(this.passwordPolicy.passwordValidationFailedMessage);
  }

  ///
  handleInput(event) {
    event.target.setCustomValidity(""); // Xóa lỗi khi nhập lại
  }

  ///
  async fetchPasswordPolicy() {
    try {
      this.isLoading = true;
      this.passwordPolicy = await passwordPolicyService.get();

    } catch (e) {
      this.toastError(e);

    } finally {
      this.isLoading = false;
    }
  }

  ///
  get isTaxCodeRequired() {
    return this.corporation === "business";
  }

  ///
  provinceSelectSearch(option, label, searchText) {
    searchText = util.sanitizeSearchText(searchText.toLowerCase());
    return util.sanitizeSearchText(label).toLowerCase().includes(searchText);
  }

  ///
  setRandomPassWord() {
    this.password = util.randomPassword(10);
    this.confirmPassword = '';
    util.clearCustomValidity();
  }

  ///
  async submitForm() {
    this.formErrorMsg = "";    
    this.address = this.address.trim();
    this.name = this.name.trim();
     if (!util.isValidUserName(this.username)) {
         this.formErrorMsg = "<b>" + this.username + "</b> " + this.$t("includespacename");
      return;
     }
    if (!validationUtils.isEmail(this.email)) {
      this.formErrorMsg = this.$t("invalidEmail").toString();
      return;
    }
    if (this.password !== this.confirmPassword) {
      this.formErrorMsg = this.$t("passwordsNotMatch").toString();
      return;
    }

    let data: any = {
      customerCode: this.code,
      areaId: this.areaFilterSelectedOption,
      username: this.username.toLowerCase(),
      password: this.password,
      confirmPassword: this.confirmPassword,
      name: this.name,
      email: this.email.toLowerCase(),
      phone: this.phoneNumber,
      // province: this.province,       
      address: this.address,
      taxCode: this.taxCode || undefined,
      documentTypeId: this.documentTypeId,
      idCard: this.idCard,
      licensePlace: this.documentIssuePlace,
      licenseDate: this.documentIssueDate,
      licenseExpirationDate: this.documentExpiryDate,
      recordingStorage: +this.recordingStorage,
      description: this.description,
      // customerType: this.corporationType,
    };

    //  if(this.corporationType === 'invnpt'){
    //   data.corporations= this.corporation
    // }else
    // {
    //   data.idType= this.corporation
    // }

    try {
        this.isSubmitting = true;
        const response = await userService.CreateCustomerAndUser(data,
          {
            validateStatus: function (status) {
              return status < 500;
            }
          }
        );
        if (response?.code === 0) {
          await this.$router.push("/customers");
          this.toastSuccessDelay(this.$t("createNewCustomerSuccessful").toString());
        }
        this.formErrorMsg = response.message;
        return;
    }
    catch (e) {
      this.formErrorMsg = "Đã xảy ra lỗi, vui lòng thử lại";
    }
    finally {
      this.isSubmitting = false;
    }
  }

}
</script>
